<div class="parallax_img" id="parallax_img"></div>

<portfolio-navigation></portfolio-navigation>

<main id="main">
    <div class="container coming-soon-container text-center px-md-4">
        <span>BREATHING TIPS</span>
        <!-- <p class="mt-4 mb-5 p-0">A learning portfolio. Designed for you. Game-changing.</p> -->
        <!-- <img class="img-fluid" src="../../../../assets/images/backgrounds/coming-soon.jpg"> -->
    </div>
    <section id="module" class="module">
        <div class="container p-5 mt-5">
            <div data-aos="fade-up">
                <!-- <div class="section-title text-left text-md-center mx-2 mx-md-0 mx-lg-0">
                    <p class="ml-0 pb-0 mt-md-3">Breathing Tips</p>
                </div> -->

                <div class="row module-container justify-content-center" data-aos="fade-up" data-aos-delay="200">
                    <div *ngFor="let tip of tips" class="col-md-6 col-lg-6 col-xl-4 module-item">
                        <!-- Video Type -->
                        <a *ngIf="tip.media_type === 'video'" [href]="tip.media" target="_blank">
                            <div class="module-wrap">
                                <div class="d-flex justify-content-center align-item-center">
                                    <img
                                        *ngIf="tip.media_type === 'image'; else videoType"
                                        [defaultImage]="preloaderImage"
                                        [lazyLoad]="tip.media" 
                                        class="module-image"
                                        [id]="'module_image_' + tip.id"
                                        (onStateChange)="moduleImageCallback($event, tip.id)"
                                    >
                                    <ng-template #videoType>
                                        <div class="d-flex tip-video-type">
                                            <img class="mx-auto my-auto" src="../../../../../assets/images/icons/play-big.svg">
                                        </div>
                                    </ng-template>
                                </div>
                                <div class="module-info" [ngStyle]="{'background-color': tip.bg_color}">
                                    <h4>{{ tip.title }}</h4>
                                    <p class="mb-0">{{ tip.text }}</p>
                                </div>
                            </div>
                        </a>

                        <!-- Non Video Type -->
                        <div *ngIf="tip.media_type !== 'video'" class="module-wrap">
                            <div class="d-flex justify-content-center align-item-center">
                                <img
                                    *ngIf="tip.media_type === 'image'; else videoType"
                                    [defaultImage]="preloaderImage"
                                    [lazyLoad]="tip.media" 
                                    class="module-image"
                                    [id]="'module_image_' + tip.id"
                                    (onStateChange)="moduleImageCallback($event, tip.id)"
                                >
                                <ng-template #videoType>
                                    <div class="d-flex tip-video-type">
                                        <img class="mx-auto my-auto" src="../../../../../assets/images/icons/play-big.svg">
                                    </div>
                                </ng-template>
                            </div>
                            <div class="module-info" [ngStyle]="{'background-color': tip.bg_color}">
                                <h4>{{ tip.title }}</h4>
                                <p class="mb-0">{{ tip.text }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Loader -->
        <modal-loader [modalText]="modalText"></modal-loader>

    </section>
</main>
